import React from 'react';
import styled from 'styled-components/macro';
import translate from './TranslateHOC';

function SectionTitle({ title, type, children }) {
  return <H2 type={type}>{title ? title : children}</H2>;
}

const H2 = styled.h2`
  ${(props) => props.theme.fontBold};
  font-size: 24px;
  font-weight: bold;
  letter-spacing: -0.025em;
  margin-bottom: 6px;
  padding: 1em 15px 0;

  ${(props) =>
    props.type === 'no-spacing' &&
    `
    margin: 0;
    padding: 0;
  `}

  ${(props) =>
    props.type === 'no-margin' &&
    `
    margin: 0;
  `}

  ${(props) =>
    props.type === 'no-padding' &&
    `
    padding: 0;
  `}

  ${(props) =>
    props.type === 'no-padding-horizontal' &&
    `padding-left: 0;
     padding-right: 0;
  `}

  ${(props) =>
    props.type === 'top-padding' &&
    `
    padding: 24px 15px 0;
  `}

  ${(props) =>
    props.type === 'no-line' &&
    `
    box-shadow: none;
  `}

  ${(props) =>
    props.type === 'on-image' &&
    `
    ${(props) => props.theme.fontBold};
    font-weight: bold;
    max-width: 1240px;
    padding: 24px 0 0.5em;
  `}

  ${(props) =>
    props.type === 'footer' &&
    `
    margin: 0 10px !important;
    padding: 1em 0 0.9em;
    font-size: 24px;
    @media screen and (min-width: 768px) {
      margin: 0 !important;
      padding: 0.8em 0 1.2em;
      font-size: 20px;
    }
  `}

  ${(props) =>
    props.type === 'categories' &&
    `
    ${props.theme.fontBold};
    box-shadow: none;
    margin-right: 0.5em;
    padding: 0;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.28px;
    @media screen and (min-width: 768px) {
      font-size: 34px;
    }
  `};

  ${(props) =>
    props.type === 'isProgramme' &&
    `font-size: 12px; line-height: 18px; letter-spacing: 0.1px;`};

  @media screen and (min-width: 768px) {
    padding-left: 0;
    ${(props) =>
      props.type === 'isProgramme' && `${props.theme.font.body.bold}`};
  }
  @media screen and (min-width: 1275px) {
    padding-left: 0;
    padding-right: 0;
  }
  @media screen and (min-width: 1440px) {
    ${(props) =>
      props.type === 'isProgramme' &&
      `
      ${props.theme.font.h5};
      margin-bottom: 0.6em;
    `};
  }
`;

export default translate(SectionTitle);
